const LANGUAGE_MAPPER: Record<string, string> = {
  'zh-tw': 'zh-TW',
};

export default LANGUAGE_MAPPER;
